import { useEffect } from "react";
import { faqs, siteName, articles } from "@/mocks/media";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(id: string, data: unknown) {
  const old = document.getElementById(id);
  if (old) old.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function Seo() {
  useEffect(() => {
    const origin = window.location.origin;
    const canonical = `${origin}/`;

    document.title = "明星黑料_危机公关辟谣反转_律师函删帖水军控评_声浪观察";

    upsertMeta("name", "description", "声浪观察聚焦明星黑料背后的公关攻防：深度解析辟谣反转、律师函与删帖记录、水军控评与危机处理的操作手法，帮你看清娱乐圈舆论场的真相与套路。");
    upsertMeta("name", "keywords", "明星黑料,明星黑料公关回应,辟谣反转,律师函,删帖记录,水军控评,危机公关,娱乐圈舆情");
    upsertMeta("name", "robots", "index, follow");
    upsertMeta("name", "author", siteName);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:title", "明星黑料背后的公关攻防_声浪观察");
    upsertMeta("property", "og:description", "深度拆解辟谣反转、律师函与删帖、水军控评与危机处理，看清娱乐舆论场的真相与套路。");
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("name", "twitter:card", "summary");
    upsertMeta("name", "twitter:title", "明星黑料背后的公关攻防_声浪观察");
    upsertMeta("name", "twitter:description", "深度拆解娱乐舆论场的公关攻防与套路。");
    upsertMeta("name", "twitter:image", canonical);

    let canon = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = canonical;

    upsertJsonLd("ld-organization", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteName,
      url: canonical,
      description: "娱乐圈舆论与危机公关的深度观察媒体。",
    });

    upsertJsonLd("ld-website", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteName,
      url: canonical,
      inLanguage: "zh-CN",
    });

    upsertJsonLd("ld-webpage", {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "明星黑料与危机公关攻防观察",
      url: canonical,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: siteName, url: canonical },
      about: "明星黑料与危机公关的辟谣反转、律师函删帖、水军控评方法拆解",
    });

    upsertJsonLd("ld-itemlist", {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "深度解读列表",
      itemListElement: articles.slice(0, 9).map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: a.title,
        description: a.summary,
      })),
    });

    upsertJsonLd("ld-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }, []);

  return null;
}